
define('text!src/plugins/summaryWidget/res/input/selectTemplate.html',[],function () { return '<div class="e-control select">\n    <select>\n    </select>\n </div>\n';});

